<template>
    <div>
        <div class="footer_box">
            <div class="footer_room" @click="$modal.show('room_search_modal')"><img src="../assets/images/footer_room.svg" alt="部屋別で検索"></div>
            <div class="footer_sukikamo_style">
                <div class="footer_sukikamo" @click="$modal.show('style_search_modal')"><img src="../assets/images/footer_sukikamo.svg" alt="スタイルで検索"></div>
                <div id="kamo_fukidashi"><img src="../assets/images/footer_fukidashi_sp.svg" alt="吹き出し"></div>
            </div>
        </div>

        <modal name="room_search_modal" width="80%" height="auto">
            <div>
                <SearchCheckBox
                        caption="部屋別で検索"
                        :items="room_tag_names"
                        :checked_items="checked_room_tag"
                        @change="setSelectedRoom"
                        @close="$modal.hide('room_search_modal')"
                />
            </div>
        </modal>

        <modal name="style_search_modal" width="80%" height="auto">
            <div>
                <SearchCheckBox
                        caption="スタイルで検索"
                        :items="style_tag_names"
                        :checked_items="checked_style_tag"
                        @change="setSelectedStyle"
                        @close="$modal.hide('style_search_modal')"
                />
            </div>
        </modal>
    </div>
</template>

<script>
    import { mapState, mapMutations } from 'vuex'
    import SearchCheckBox from '../components/SearchCheckBox'
    import Ajax from '../assets/js/Ajax'

    export default {
        name: "SearchFooter",
        components: { SearchCheckBox },
        data: () => ({
            style_tags: [],
            room_tags: [],
        }),
        computed: {
            ...mapState('search', ['search_conditions']),
            style_tag_names: _this => _this.style_tags.map(tag => tag.name_ja),
            room_tag_names: _this => _this.room_tags.map(tag => tag.name_ja),
            checked_style_tag: _this => _this.search_conditions.filter(tag => tag.category === 'style').map(tag => tag.name_ja),
            checked_room_tag: _this => _this.search_conditions.filter(tag => tag.category === 'room').map(tag => tag.name_ja),
        },
        async created() {
            const {style, room} = await Ajax.getSearchTags();
            this.style_tags = style;
            this.room_tags = room;
        },
        methods: {
            ...mapMutations('search', ["setSearchConditions"]),
            setSelectedStyle(tags) {
                const current_tags_without_style_tag = this.search_conditions.filter(t => t.category !== 'style').map(t => t.name_ja);
                const tags_ja = [...current_tags_without_style_tag, ...tags];
                this.emitSearchConditions(tags_ja);
            },
            setSelectedRoom(tags) {
                const current_tags_without_room_tag = this.search_conditions.filter(t => t.category !== 'room').map(t => t.name_ja);
                const tags_ja = [...current_tags_without_room_tag, ...tags];
                this.emitSearchConditions(tags_ja);
            },
            async emitSearchConditions(tags_ja) {
                const tag_data = await Ajax.getTagData();
                const tags = tags_ja
                    .map(tag => tag_data.find(t => t.name_ja === tag))
                    .filter(d => d);
                this.setSearchConditions(tags);
                const query_param = this.generateQueryParam('tags[]', tags_ja);
                await this.$router.push('/?' + query_param, () => {});
            },
            generateQueryParam(name, params) {
                const url_search_params = new URLSearchParams();
                for(const param of params) url_search_params.append(name, param);
                return url_search_params.toString();
            }
        },
        mounted(){
            // 指を離したら
            var kamo_fukidashi = document.querySelector("#kamo_fukidashi");
            window.addEventListener("touchend", function (event) {
                var fn = function() {
                    // console.log("指離し");
                    kamo_fukidashi.style.display = "block" ;
                };
                var tm = 4000;
                setTimeout(fn,tm);
            });
            //タッチしたら
            window.addEventListener("touchstart", function (event) {
                // console.log("タッチ中");
                kamo_fukidashi.style.display = "none" ;
            });
        }
    };


</script>

<style scoped lang="scss">
    .footer_box {
        display: flex;
        width: 100%;
        height: 65px;
        padding: 10px 10px 10px 0;
        box-sizing: border-box;
        background-color: white;

        .footer_help_btn_sp img {
            height: 45px;
        }
        .footer_room {
            margin: 0 5px 0 auto;
            img {
                height: 45px;
            }
        }
        .footer_sukikamo_style {
            position: relative;
            .footer_sukikamo {
                margin-top: -39px;
                img {
                    height: 84px;
                }
            }
            #kamo_fukidashi {
                display: none;
                position: absolute;
                top: -160px;
                left: -10px;
            }
        }
    }
</style>
